// --- Helper Functions ---

export const parseTimeToMinutes = (timeStr) => {
    if (!timeStr || !timeStr.includes(':')) return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) return 0;
    return hours * 60 + minutes;
};

export const getDatesInRange = (startDate, endDate) => {
    const dates = [];
    if (!startDate || !endDate) return [];
    let currentDate = new Date(startDate);
    const lastDate = new Date(endDate);
    if (isNaN(currentDate.getTime()) || isNaN(lastDate.getTime())) return [];

    while (currentDate <= lastDate) {
        dates.push(currentDate.toISOString().slice(0, 10));
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
};

const formatCalendarDate = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return '';
    const date = new Date(`${dateStr}T${timeStr}`);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().replace(/-|:|\.\d{3}/g, '');
};

export const downloadAllEventsIcs = (events, seminarName) => {
    let icsContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//MySeminarApp//NONSGML v1.0//EN',
    ];

    events.forEach(event => {
        const startTime = formatCalendarDate(event.date, event.time);
        const endTime = formatCalendarDate(event.date, event.endTime);
        const uid = `event-${event.id}@myseminar.app`;

        icsContent.push(
            'BEGIN:VEVENT',
            `UID:${uid}`,
            `DTSTAMP:${new Date().toISOString().replace(/-|:|\.\d{3}/g, '')}`,
            `DTSTART:${startTime}`,
            `DTEND:${endTime}`,
            `SUMMARY:${event.title}`,
            `DESCRIPTION:${event.description || ''}`,
            `LOCATION:${event.room || ''}`,
            'END:VEVENT'
        );
    });

    icsContent.push('END:VCALENDAR');

    const blob = new Blob([icsContent.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${seminarName.replace(/ /g, '_')}_calendar.ics`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};